import React, { useRef, useCallback, useMemo } from 'react';

import { SideNavContent } from '@atlaskit/navigation-system/layout/side-nav';

import { SideNavigationContext } from '@confluence/page-layout-side-navigation-context/entry-points/SideNavigationContext.ts';

export const SideNavigationContent = ({ children }) => {
	const sideNavRef = useRef<HTMLDivElement>(null);

	const handleScrollToTop = useCallback(() => {
		if (sideNavRef.current) {
			sideNavRef.current.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
	}, [sideNavRef]);

	const contextValue = useMemo(
		() => ({ sideNavRef, handleScrollToTop }),
		[sideNavRef, handleScrollToTop],
	);

	return (
		<SideNavigationContext.Provider value={contextValue}>
			<SideNavContent testId="side-navigation-content" ref={sideNavRef}>
				{children}
			</SideNavContent>
		</SideNavigationContext.Provider>
	);
};
